import { useMutation } from "@tanstack/react-query";

import { prepareAnonymousForecast } from "services";

import { MUTATE_PREPARE_ANONYMOUS_FORECAST } from "consts";

import { PrepareAnonymousForecastRequestBody } from "models";

export const useMutatePrepareAnonymousForecast = () =>
  useMutation({
    mutationKey: [MUTATE_PREPARE_ANONYMOUS_FORECAST],
    mutationFn: (body: PrepareAnonymousForecastRequestBody) => prepareAnonymousForecast(body, { hideErrorMessage: true }),
  });
